import { INTEGRATIONS_APPS } from 'integrations-lib/constants/AppIds';
import { apiKeyValidator as anthropicApiKeyValidator } from '../Anthropic/utils/apiKeyValidator';
import { apiKeyValidator as cohereApiKeyValidator } from '../Cohere/utils/apiKeyValidator';
import { apiKeyValidator as geminiApiKeyValidator } from '../Gemini/utils/apiKeyValidator';
import { apiKeyValidator as openAiApiKeyValidator } from '../OpenAi/utils/apiKeyValidator';
import { apiKeyValidator as xaiApiKeyValidator } from '../Xai/utils/apiKeyValidator';
import { handleAnthropicApiKeyUpdate, handleCohereApiKeyUpdate, handleGeminiApiKeyUpdate, handleOpenaiApiKeyUpdate, handleXaiApiKeyUpdate } from './utils/apiHandlers';
export const AI_APPS_DATA = {
  [INTEGRATIONS_APPS.ANTHROPIC]: {
    validateApiKey: anthropicApiKeyValidator,
    submitApiKey: handleAnthropicApiKeyUpdate,
    helpLink: 'https://console.anthropic.com/account/keys',
    consoleName: 'Anthropic'
  },
  [INTEGRATIONS_APPS.COHERE]: {
    validateApiKey: cohereApiKeyValidator,
    submitApiKey: handleCohereApiKeyUpdate,
    helpLink: 'https://dashboard.cohere.com/api-keys',
    consoleName: 'Cohere'
  },
  [INTEGRATIONS_APPS.GEMINI]: {
    validateApiKey: geminiApiKeyValidator,
    submitApiKey: handleGeminiApiKeyUpdate,
    helpLink: 'https://aistudio.google.com/apikey',
    consoleName: 'Google AI Studio'
  },
  [INTEGRATIONS_APPS.OPENAI]: {
    validateApiKey: openAiApiKeyValidator,
    submitApiKey: handleOpenaiApiKeyUpdate,
    helpLink: 'https://platform.openai.com/api-keys',
    consoleName: 'OpenAI'
  },
  [INTEGRATIONS_APPS.XAI]: {
    validateApiKey: xaiApiKeyValidator,
    submitApiKey: handleXaiApiKeyUpdate,
    helpLink: 'https://console.x.ai',
    consoleName: 'xAI'
  }
};